// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15 2H2V15H7.5V13H4V4H13V7.5H15V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 9H9V22H22V9ZM13.5002 14.0859L15.0002 15.5859L18.0002 12.5859L19.4144 14.0002L15.0002 18.4144L12.0859 15.5002L13.5002 14.0859Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-checkbox-filled')
export default class ComponentCheckboxFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-checkbox-filled',
    }
  }
}
